import Alpine from 'alpinejs';
import Splide from './components/Splide';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';

Alpine.data('Splide', Splide);


window.Alpine = Alpine;

Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.start();
